import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <div className="wrap hero__grid">
        <div className="hero__text">
          <h1 className="hero__name">
            <span className="hero__line"><span>Olivier</span></span>
            <span className="hero__line"><span>Gautheron</span></span>
          </h1>
          <p className="hero__role">{t('heroTitle')}</p>
          <p className="lede">{t('aboutIntro')}</p>
          <div className="actions">
            <Link to="/projects" className="btn btn-primary">
              {t('viewProjects')}
            </Link>
            <Link to={{ pathname: '/', hash: '#contact' }} className="btn btn-secondary">
              {t('getInTouch')}
            </Link>
            <a href="/resume.pdf" download className="text-link">
              {t('downloadResume')}
            </a>
          </div>
        </div>

        <img
          className="hero__photo"
          src="/imgs/photo-profile.jpg"
          alt="Olivier Gautheron"
          width="360"
          height="450"
        />
      </div>

      <div className="wrap hero__more">
        <div className="split">
          <h2 className="split__label">{t('aboutTitle')}</h2>
          <div className="split__body">
            <p className="prose">{t('aboutBackground')}</p>
            <p className="prose">{t('aboutPassion')}</p>

            <h3 className="subhead">{t('coreSkills')}</h3>
            <ul className="rule-list">
              {t('aboutSkills').map((skill) => (
                <li key={skill}>{skill}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
